import React from "react";
import { Route, BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import NavigationContainer from "./pages/NavigationContainer";

import { authRequest, setAllowRedirect } from "./actions/appActions";
import { getUser } from "./actions/userActions";
import {debug_processUser} from "./Atollon/debug";
import {getReactRouterBasename} from "./constants";


const App = ({ store }) => (
  <Provider store={store}>
    <Router basename={getReactRouterBasename()}>
      <Route path="/" component={NavigationContainer} />
    </Router>
  </Provider>
);

export default compose(
  connect(null, { getUser, authRequest, setAllowRedirect }),
  lifecycle({
    async componentWillMount() {
      const { getUser, authRequest, setAllowRedirect } = this.props;

      if (/^[^?]+\?OAuth2AuthCode=.+$/.test(window.location.href)) {
          let OAuth2AuthCode = window.location.href.match(/=[^=]+$/g)[0].substr(1);
        setAllowRedirect(false);
        if (
          await authRequest(OAuth2AuthCode)
        ) {
          window.location.replace(
            window.location.href.replace(/\?OAuth2AuthCode=.+$/, "")
          );
        }
      } else if (
        !/^[^?]+\?activateAccount=.+$/.test(window.location.href) &&
        !/.+\/server-down$/.test(window.location.href)
      ) {
        let user = await getUser();
        //debug_processUser( user );
      }
    }
  })
)(App);



// WEBPACK FOOTER //
// ./src/App.js